import { render, staticRenderFns } from "./InfoImport.vue?vue&type=template&id=86ebedc8&"
import script from "./InfoImport.vue?vue&type=script&lang=js&"
export * from "./InfoImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports